import { render, staticRenderFns } from "./OpeningLeadSelectField.vue?vue&type=template&id=36cb5ede&scoped=true&"
import script from "./OpeningLeadSelectField.vue?vue&type=script&lang=js&"
export * from "./OpeningLeadSelectField.vue?vue&type=script&lang=js&"
import style0 from "./OpeningLeadSelectField.vue?vue&type=style&index=0&id=36cb5ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb5ede",
  null
  
)

export default component.exports